import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import news from './modules/news';
import activities from './modules/activities';


Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const state = {
    user: {
        
    },
    showLoading: false
}

export default new Vuex.Store({
    state,
    actions,
    getters,
    mutations,
    modules: {
        news,
        activities
    },
    strict: debug,
    plugins: debug ? [] : []
});


// WEBPACK FOOTER //
// ./src/store/index.js